import {
  InteractiveComponent,
  SelectionComponent
} from '../../models/LessonComponent';

import AssetService from '../../../shared/services/AssetService';
import DefaultImage from '../../images/default-image.jpg';
import { LessonComponentContentProps } from '../LessonComponentContentView';
import MultipleSelection from './multiple_selection/MultipleSelection';
import React from 'react';
import SingleSelection from './single_selection/SingleSelection';
import WithQuestion from './WithQuestion';
import styles from '../../styles/WithMedia.module.css';

export default function WithMedia(props: LessonComponentContentProps) {
  const component = props.component as SelectionComponent;
  const { assetkey, selectionSettings } = component?.settings;
  const imagePosition =
    component?.settings?.imagePosition ||
    'bottom'; /** set default as 'bottom' to support the existing components */
  const type = component?.type;
  const url = AssetService.getAssetUrl(assetkey);

  const DisplayMedia = () => {
    return (
      <div
        className={
          imagePosition === 'top' ? styles.imageAbove : styles.imageBelow
        }
      >
        {selectionSettings?.displayMode === 'image' ? (
          <img className={styles.image} src={url || DefaultImage} />
        ) : (
          selectionSettings?.displayMode === 'video' && (
            <div className={styles.videoContainer}>
              <video className={styles.video} controls src={url || ''} />
            </div>
          )
        )}
      </div>
    );
  };

  return (
    <>
      {/* Display media(image/video) above question */}
      {imagePosition === 'top' && url && <DisplayMedia />}
      <WithQuestion component={props.component as InteractiveComponent}>
        <>
          {/* Display media(image/video) below question */}
          {imagePosition === 'bottom' && url && <DisplayMedia />}
          {type === 'single_selection' ? (
            <SingleSelection
              component={component}
              response={props.response}
              onChange={props.onChange}
            />
          ) : (
            <MultipleSelection
              component={component}
              response={props.response}
              onChange={props.onChange}
            />
          )}
        </>
      </WithQuestion>
    </>
  );
}
